import LibraryAddRoundedIcon from '@mui/icons-material/LibraryAddRounded';
import { Box, Button, IconButton, Tooltip } from '@mui/material';

import { usePageContext } from '~/hooks/usePageContext';

import { useKnowledgeCapture } from './KnowledgeCaptureProvider';

type OpenAddKnowledge = NonNullable<ReturnType<typeof useKnowledgeCapture>>['openAddKnowledge'];

function RailButton({
  collapsed,
  openAddKnowledge,
}: {
  collapsed: boolean;
  openAddKnowledge: OpenAddKnowledge;
}) {
  const { propertyId, carId } = usePageContext();
  // On a property or elevator page the dialog opens already pointed at it.
  const open = () => openAddKnowledge(propertyId ? { target: { propertyId, carId } } : {});

  if (collapsed) {
    return (
      <Tooltip title="Add knowledge" placement="right">
        <IconButton
          aria-label="Add knowledge"
          onClick={open}
          sx={{ width: '100%', borderRadius: 1 }}
        >
          <LibraryAddRoundedIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    );
  }
  return (
    <Button
      variant="text"
      onClick={open}
      startIcon={<LibraryAddRoundedIcon fontSize="small" />}
      sx={{
        width: '100%',
        justifyContent: 'flex-start',
        px: 1.5,
        textTransform: 'none',
        fontSize: 14,
        fontWeight: 500,
        whiteSpace: 'nowrap',
      }}
    >
      Add knowledge
    </Button>
  );
}

export function AddKnowledgeRailButton({ collapsed = false }: { collapsed?: boolean }) {
  const capture = useKnowledgeCapture();
  if (!capture) return null;
  return (
    <Box sx={{ px: 0.75, mt: -1, pb: 1 }}>
      <RailButton collapsed={collapsed} openAddKnowledge={capture.openAddKnowledge} />
    </Box>
  );
}
